import axios, { AxiosResponse } from 'axios';
import * as moment from 'moment';
import { Week } from 'src/store/weeks/types';
import { uploadImage, validateFile } from 'src/utils/imageHelper';
import { action } from 'typesafe-actions';
import { ImageActionTypes } from '../image/types';
import { apiUrl, history } from './../../index';
import { alertError, alertSuccess } from './../alert/actions';
import { Season } from './../season/types';
import { CardEvent, CardEventGroup, CreateEventData, EventActionTypes } from './types';

export const getEventsbyWeek = (week: Week, sectionTitle: string) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_WEEK_REQUEST, week.id);
  const fetchSuccess = (data: CardEvent[], weekId: number) =>
    action(EventActionTypes.FETCH_SUCCESS, { data, weekId });
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    console.log(
      'GETTING EVENTS FROM ',
      moment(week.startDate).toString(),
      ' - ',
      moment(week.endDate).toString()
    );

    axios
      .get(apiUrl + '/events/', {
        params: {
          sectionTitle,
          from: moment(week.startDate).toString(),
          to: moment(week.endDate).toString()
        }
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('GOT EVENTS ', res.data.events.length);
        dispatch(fetchSuccess(res.data.events, week.id));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getEventsPerDay = (day: moment.Moment, sectionTitle: string) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_WEEK_REQUEST);
  const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.FETCH_DAILY_EVENTS, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/', {
        params: {
          sectionTitle,
          from: moment(day)
            .set({ h: 0, m: 0, s: 0 })
            .toString(),
          to: moment(day)
            .set({ h: 23, m: 59, s: 59 })
            .toString()
        }
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('GOT EVENTS ', res.data.events.length);
        dispatch(fetchSuccess(res.data.events));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const createEvent = (event: CreateEventData, file?: File, successCB?: () => any) => {
  const fetchRequest = () => action(EventActionTypes.CREATE_REQUEST);
  const fetchSuccess = (data: CardEventGroup) => action(EventActionTypes.CREATE_SUCCESS, { data });
  const fetchError = (error: Error) => action(EventActionTypes.CREATE_ERROR, error);

  interface Response {
    cardeventgroup: CardEventGroup;
  }

  return (dispatch: any) => {
    if (file && !validateFile(dispatch, file)) {
      return;
    }
    dispatch(fetchRequest());

    axios
      .post(apiUrl + '/events/periodical/create', event)
      .then((res: AxiosResponse<Response>) => {
        if (file) {
          dispatch(action(ImageActionTypes.UPLOAD_IMAGE));
          const data = new FormData();
          data.set('eventgroupId', '' + res.data.cardeventgroup.id);
          uploadImage('eventgroup', file, data)
            .then(() => {
              dispatch(action(ImageActionTypes.UPLOAD_SUCCESS));
              dispatch(fetchSuccess(res.data.cardeventgroup));
              dispatch(alertSuccess('Event erfolgreich erstellt!'));
              if (successCB !== undefined) {
                successCB();
              }
            })
            .catch(err => {
              dispatch(action(ImageActionTypes.UPLOAD_ERROR));
              dispatch(fetchError(err));
              dispatch(alertError(new Error('Bild hinzufügen fehlgeschlagen')));
            });
        } else {
          dispatch(fetchSuccess(res.data.cardeventgroup));
          dispatch(alertSuccess('Event erfolgreich erstellt!'));
          if (successCB !== undefined) {
            successCB();
          }
        }
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

const success = (dispatch: any, fs: any, res: any, redirect = true) => {
  dispatch(fs(res.data.cardeventgroup));
  if (redirect) {
    const split = history.location.pathname.split('/');
    split.splice(split.length - 2, 2);
    history.push(split.join('/'));
  }
  dispatch(alertSuccess('Event erfolgreich bearbeitet!'));
};

export const updateEvent = (event: CreateEventData, file?: File) => {
  const fetchRequest = () => action(EventActionTypes.CREATE_REQUEST);
  const fetchSuccess = (data: CardEventGroup) => action(EventActionTypes.CREATE_SUCCESS, { data });
  const fetchError = (error: Error) => action(EventActionTypes.CREATE_ERROR, error);

  interface Response {
    cardeventgroup: CardEventGroup;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());
    console.log('WE IN THIS ');
    if (event.section != null) {
      console.log(event.section.title);
      event.sectionTitle = '' + event.section.title;
    }
    console.log(event.sectionTitle);
    axios
      .put(apiUrl + '/events/periodical/', event)
      .then((res: AxiosResponse<Response>) => {
        if (file) {
          const data = new FormData();
          data.set('eventgroupId', '' + event.eventgroupId);

          uploadImage('eventgroup', file, data)
            .then(() => {
              success(dispatch, fetchSuccess, res, false);
            })
            .catch(err => {
              dispatch(fetchError(err));
              dispatch(alertError(new Error('Bild hinzufügen fehlgeschlagen')));
            });
        } else {
          success(dispatch, fetchSuccess, res, false);
        }
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getEventById = (eventId: number) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent) => action(EventActionTypes.FETCH_SINGLE_SUCCESS, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    event: CardEvent;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/' + eventId)
      .then((res: AxiosResponse<Response>) => {
        console.log(res.data.event);
        dispatch(fetchSuccess(res.data.event));
      })
      .catch(err => {
        if (err.status === 404) {
          history.push('/404');
        }
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const deleteEvents = (
  cardGroupId: number,
  dontRedirect?: boolean,
  successCB?: () => any
) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (cardGId: number) => action(EventActionTypes.DELETE_EVENTS, cardGId);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .delete(apiUrl + '/events/periodical/' + cardGroupId)
      .then(() => {
        dispatch(fetchSuccess(cardGroupId));
        if (dontRedirect === undefined || dontRedirect === false) {
          history.push('/');
        }
        dispatch(alertSuccess('Event gelöscht!'));
        if (successCB) {
          successCB();
        }
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getEvents = () => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.FETCH_ALL_SUCCESS, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/')
      .then((res: AxiosResponse<Response>) => {
        console.log('GOT ALL EVENTS ', res.data.events.length);
        dispatch(fetchSuccess(res.data.events));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getEventsBySeason = (sectionTitle: string, season: Season) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (events: CardEvent[], seasonId: number) =>
    action(EventActionTypes.FETCH_SEASON_SUCCESS, { events, seasonId });
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/', {
        params: {
          sectionTitle,
          from: moment(season.startdate).toString(),
          to: moment(season.enddate).toString()
        }
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('GOT EVENTS ', res.data.events.length);
        dispatch(fetchSuccess(res.data.events, season.id));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getEventsDaily = (day: moment.Moment) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.FETCH_DAILY_EVENTS, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + `/events/daily`, {
        params: {
          day: moment(day)
            .set({ h: 0, m: 0, s: 0 })
            .toISOString()
        }
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('GOT DAILY EVENTS', res.data.events.length);
        dispatch(fetchSuccess(res.data.events));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const hideSingleEvent = (event: CardEvent) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.HIDE_EVENT, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    const events = [{ ...event, participants: undefined, guides: undefined }];

    axios
      .put(`${apiUrl}/events/hide/`, { events })
      .then((res: AxiosResponse<Response>) => {
        dispatch(fetchSuccess(res.data.events));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const hideEvents = (events: CardEvent[], successCB: () => any) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.HIDE_EVENTS, data);
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    events: CardEvent[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .put(`${apiUrl}/events/hide/`, { events })
      .then((res: AxiosResponse<Response>) => {
        dispatch(alertSuccess('Änderungen gespeichert'));
        dispatch(fetchSuccess(res.data.events));
        successCB();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

// export const unhideEvent = (event: CardEvent) => {
//   const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
//   const fetchSuccess = (data: CardEvent[]) => action(EventActionTypes.UNHIDE_EVENT, data);
//   const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

//   interface Response {
//     events: CardEvent[];
//   }

//   return (dispatch: any) => {
//     dispatch(fetchRequest());

//     const events = [{ id: event.id, eventgroup: event.eventgroup, hidden: false }];

//     axios
//       .put(`${apiUrl}/events/hide`, { events })
//       .then((res: AxiosResponse<Response>) => {
//         dispatch(fetchSuccess(res.data.events));
//       })
//       .catch(err => {
//         dispatch(fetchError(err));
//         dispatch(alertError(err));
//       });
//   };
// };

export const getEventbyGroupID = (cardGroupId: number) => {
  const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEvent[]) =>
    action(EventActionTypes.FETCH_EVENT_CARDGROUP, { data, cardGroupId });
  const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

  interface Response {
    event: CardEventGroup;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/eventgroup/' + cardGroupId)
      .then((res: AxiosResponse<Response>) => {
        console.log(res.data.event.events);
        dispatch(fetchSuccess(res.data.event.events));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/events/actions.ts